<template>
  <v-footer
    color="grey lighten-3 px-6 py-3"
    height="auto"
    min-height="64"
  >
    <v-row
      class="align-center"
      :justify="$vuetify.breakpoint.mdAndUp ? 'space-between' : 'center'"
    >
      <!-- © 2019 Estudio gamboa y cia. -->
      <span>{{ copyright }}</span>
      <v-col
        class="hidden-md-and-up"
        cols="12"
      />

<!--      <div>-->
<!--        <v-icon>mdi-facebook</v-icon>-->
<!--        &nbsp;-->
<!--        <v-icon>mdi-twitter</v-icon>-->
<!--      </div>-->
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    computed: {
      copyright () {
        let currentDate = new Date()
        let year = currentDate.getFullYear()
        let footerCopyright = '© ' + year + ' Estudio gamboa y cia.'
        return footerCopyright
      }
    }
  }
</script>

<style lang="sass" scoped>
  .v-footer a
    text-decoration: none
  .v-footer span
    font-size: 12px
</style>
